export enum ContentType {
    IMAGE = "IMAGE",
    TEXT = "TEXT",
    OPTIONS = "OPTIONS"
}

export abstract class Content {
    abstract getType(): ContentType;
}